'use client'
import React, { useContext, useEffect, useState } from 'react'
import Application from '../../StateContext/Application';

const HOTickets = () => {

    const statecalls = useContext(Application);
    const { GetHOComplaints } = statecalls;
    const [activetickets, setActiveTickets] = useState([])

    useEffect(() => {
        GetActive()
    }, [])

    async function GetActive() {
        let data = await GetHOComplaints()
        console.log(data[0]);
        setActiveTickets(data)
    }

    function showtable(e) {
        return (
            <tr>
                <td className="border border-slate-300">{e.fullname}</td>
                <td className="border border-slate-300">{e.ward}</td>
                <td className="border border-slate-300">{e.TicketNumber}</td>
                <td className="border border-slate-300">
                    <a href={"/Admin/Complaints/" + e.TicketNumber + '/' + e.fullname}>
                        <button type='button' className="btn btn-primary">
                            <img src="/chat.png" alt="Search" style={{ marginRight: "4px" }} />Chat
                        </button></a>
                </td>
            </tr>
        )



    }
    return (
        <>
            <div className='grid justify-center'>
                <h3 style={{ padding: '10px' }}>HO Tickets</h3>
                <div style={{ width: '75vw', backgroundColor: 'white', borderRadius: '15px', margin: '25px 45px', textAlign: 'start' }}>

                    <table className="border-collapse border border-slate-400 mt-2 text-center table table-bordered">
                        <thead className='table-primary'>
                            <tr>
                                <th className="border bg-slate-300">Fullname</th>
                                <th className="border bg-slate-300">Department</th>
                                <th className="border bg-slate-300">Ticket ID</th>
                                <th className="border bg-slate-300">Complaint Type</th>
                                <th className="border bg-slate-300">Message</th>
                                <th className="border bg-slate-300">Ticket Status</th>
                                <th className="border bg-slate-300">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* {Array.isArray && activetickets  && activetickets.length > 0 ? (

                                <Pagination data={activetickets} perPageItems={5} func={c => showtable(c)} searchparam={["fullname", "ContactNumber", "ward"]} searchword={""} useeffectactive={activetickets} />
                            ) : (
                                <tr>
                                    <td colSpan="14">No data available</td>
                                </tr>
                            )} */}
                            {
                                Array.isArray(activetickets) && activetickets.length > 0 ? (
                                    activetickets.map((ticket, index) => (
                                        <tr key={index}>
                                            <td>{ticket.fullname}</td>
                                            <td>{ticket.Deparment}</td>
                                            <td>{ticket.TicketNumber}</td>
                                            <td>{ticket.Complaint_Type}</td>
                                            <td>{ticket.Message}</td>
                                            <td>{ticket.TicketStatus}</td>
                                            <td>
                                                {
                                                ticket.TicketStatus === 'Open' &&
                                                    <a
                                                        href={`/AdminDashboard/ViewChatForAdmin/${ticket.TicketNumber}/${ticket.fullname}`}
                                                    >
                                                        <button type="button" className="btn btn-primary">
                                                            {/* <img
                                                            src="/chat.png"
                                                            alt="Search"
                                                            style={{ marginRight: "4px" }}
                                                        /> */}
                                                            Chat
                                                        </button>
                                                    </a>
                                            }
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="14">No data available</td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default HOTickets